import { useRouter as useExpoRouter } from 'expo-router'

export function useRouter() {
  const router = useExpoRouter()
  return {
    ...router,
    navigate: (href: any, options?: any) => router.navigate(href, options),
    push: (href: any, options?: any) => router.push(href, options),
    replace: (href: any, options?: any) => router.replace(href, options),
    back: () => (router.canGoBack() ? router.back() : router.replace('/home'))
  }
}
